<template>
  <header class="sku_goods-head">
    <van-image :src="data.image_url" fit="cover"/>
    <div class="goods-info">
      <h3 class="goods-title">{{data.title}}</h3>
      <div class="goods-price">
        <b>商城价</b>
        <div class="price">
          <span v-if="data.min_price!==data.max_price">￥{{data.min_price.toFixed(2)}} -</span>
          <span>￥{{data.max_price.toFixed(2)}}</span>
          <span v-if="data.trade_point">+ {{data.trade_point}}分</span>
        </div>
        <div class="origin-price" v-if="data.origin_price!==data.min_price">￥{{data.origin_price.toFixed(2)}}</div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
	name: 'GoodsHead',
	props: {
	  data: Object
	},
	components: {},
	data() {
	  return {};
	},
	created() {
	},
	methods: {},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .sku_goods-head {
    display: flex;
    align-items: center;
    padding: 10px;

    .van-image {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
      border-radius: 4px;
      overflow: hidden;
    }

    .goods-info {
      padding: 0 10px;
      height: 80px;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;

      .goods-title {
        .limit-line;
        line-height: 24px;
        font-size: 16px;
      }

      .goods-price {
        font-size: 13px;
        display: flex;
        align-items: center;

        .price {
          flex: 1;
          color: #ff6400;
          padding-left: 10px;
        }

        .origin-price {
          text-decoration: line-through;
          color: @text-color-gray;
        }
      }
    }
  }
</style>
